var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EndOfFlow',{attrs:{"step":_vm.step},on:{"goToHome":_vm.goToHome}})}
var staticRenderFns = []

export { render, staticRenderFns }